import { ScaleFactorProvider } from "arkh";
import React from "react";
import { useWindowDimensions } from "react-native";
import { UnitSizeProvider } from "../OS/UnitSizeProvider";

export const ScreenScaled = ({ children }: React.PropsWithChildren<{}>) => {
  const { width, height } = useWindowDimensions();

  const scaleFactor = Math.min(width / 1280, height / 837);

  return (
    <ScaleFactorProvider value={scaleFactor}>
      <UnitSizeProvider value={scaleFactor / 236}>
        {children}
      </UnitSizeProvider>
    </ScaleFactorProvider>
  );
};
